(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview-parts/assets/javascripts/use-overview-footer.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview-parts/assets/javascripts/use-overview-footer.js');
"use strict";

const _React = React,
  useContext = _React.useContext,
  useMemo = _React.useMemo;
const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const productIds = svs.utils.products.productIds;
const _svs$components$tipse = svs.components.tipsen.couponOverviewParts,
  CouponFooterFulltraffRows = _svs$components$tipse.CouponFooterFulltraffRows,
  CouponFooterSystemRows = _svs$components$tipse.CouponFooterSystemRows,
  CouponFooterHedges = _svs$components$tipse.CouponFooterHedges,
  CouponFooterScore = _svs$components$tipse.CouponFooterScore;
const SYSTEM_REDUCERA_FRITT = svs.components.tipsen.engine.constants.systems.SYSTEM_REDUCERA_FRITT;
const getCouponFooter = (productId, systemType) => {
  if (productId === productIds.FULLTRAFF) {
    return CouponFooterFulltraffRows;
  } else if (productId === productIds.BOMBEN) {
    return CouponFooterScore;
  } else if (systemType && systemType === SYSTEM_REDUCERA_FRITT) {
    return CouponFooterSystemRows;
  }
  return CouponFooterHedges;
};
const useOverviewFooter = systemType => {
  const _useContext = useContext(DrawContext),
    productId = _useContext.productId;
  return useMemo(() => getCouponFooter(productId, systemType), [productId, systemType]);
};
setGlobal('svs.components.tipsen.couponOverviewParts', {
  useOverviewFooter
});

 })(window);